import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "./components/pages/Login";
import Signup from "./components/pages/Signup";
import Home from "./components/pages/Home";
import Projects from "./components/pages/Projects";
import Profile from "./components/pages/Profile";
import AddOrEditPost from "./components/pages/AddOrEditPost";
import Post from "./components/pages/Post";
import PrivateRoute from "./utils/PrivateRoute";
import NotFound404 from "./components/pages/NotFound404";
import Toaster from "./components/UI/Toaster";

const App: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen h-full">
      <div className="flex-grow">
        <Routes>
          <Route path="*" element={<NotFound404 />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/" Component={Home} />
          <Route path="/projects" Component={Projects} />
          <Route path="/post-details/:postId" element={<Post />} />
          <Route path="/post/:postId?" element={<PrivateRoute element={<AddOrEditPost />} />} />
          <Route path="/profile/:userId" element={<PrivateRoute element={<Profile />} />} />

          {/*<Route path="/" element={<Navigate to="/home" replace />} /> */}
        </Routes>
      </div>
      <Toaster />
    </div>
  );
};

export default App;
